/* GutBio — auto review slider. Groups adjacent .testimonial-card elements
   (2+) into a swipeable slider with dots, arrows and gentle autoplay.
   Progressive enhancement; re-runs on shopify:section:load for the editor. */
(function () {
  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build(cards) {
    var parent = cards[0].parentNode;
    var wrap = document.createElement('div'); wrap.className = 'gb-revslider';
    var track = document.createElement('div'); track.className = 'gb-revslider__track';
    parent.insertBefore(wrap, cards[0]);
    cards.forEach(function (c) { track.appendChild(c); });
    wrap.appendChild(track);

    var dots = document.createElement('div'); dots.className = 'gb-revslider__dots';
    var dotEls = cards.map(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'gb-revslider__dot';
      b.setAttribute('aria-label', 'Go to review ' + (i + 1));
      b.addEventListener('click', function () { go(i); });
      dots.appendChild(b); return b;
    });
    wrap.appendChild(dots);

    function mkArrow(cls, label, glyph, dir) {
      var a = document.createElement('button');
      a.type = 'button'; a.className = 'gb-revslider__arrow ' + cls;
      a.setAttribute('aria-label', label); a.innerHTML = glyph;
      a.addEventListener('click', function () { go(current() + dir); });
      wrap.appendChild(a);
    }
    mkArrow('gb-revslider__arrow--prev', 'Previous review', '‹', -1);
    mkArrow('gb-revslider__arrow--next', 'Next review', '›', 1);

    function current() {
      var best = 0, bd = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft - track.scrollLeft);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    function go(i) {
      i = (i % cards.length + cards.length) % cards.length;
      track.scrollTo({ left: cards[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    function sync() {
      var c = current();
      dotEls.forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
    }
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });
    sync();

    if (!reduce) {
      var timer = null;
      function start() { stop(); timer = setInterval(function () { go(current() + 1); }, 5500); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      start();
      ['pointerdown', 'mouseenter', 'touchstart', 'focusin'].forEach(function (ev) {
        wrap.addEventListener(ev, stop, { passive: true });
      });
      wrap.addEventListener('mouseleave', start);
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = Array.prototype.slice.call(scope.querySelectorAll('.testimonial-card'));
    var used = [];
    cards.forEach(function (card) {
      if (used.indexOf(card) > -1 || card.closest('.gb-revslider')) return;
      var run = [card], n = card.nextElementSibling;
      while (n && n.classList && n.classList.contains('testimonial-card')) {
        run.push(n); n = n.nextElementSibling;
      }
      run.forEach(function (c) { used.push(c); });
      if (run.length >= 2) build(run);
    });
  }

  function init() { scan(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
